<div mat-dialog-title>
    <h5 *ngIf="!isEditMode">{{ 'aumico_templates_group_form_create_group' | i18next }}</h5>
    <h5 *ngIf="isEditMode">{{ 'aumico_templates_group_form_update_group' | i18next }}</h5>
</div>
<div mat-dialog-content class="form" *ngIf="!isDefault">
    <mat-form-field>
        <mat-label>{{ 'aumico_templates_name' | i18next }}</mat-label>
        <input matInput [formControl]="nameControl" id="name-input" />
        <mat-error *ngIf="nameControl.hasError('required')">
            {{ 'aumico_templates_group_form_enter_group_name_error' | i18next }}
        </mat-error>
        <mat-error *ngIf="nameControl.hasError('groupNameExists')">
            {{ 'aumico_templates_group_form_name_already_exists_error' | i18next }}
        </mat-error>
    </mat-form-field>
    <br />
    <div [formGroup]="titleFormGroup">
        <mat-form-field>
            <mat-label>{{ 'aumico_templates_group_form_title' | i18next }}</mat-label>
            <input matInput formControlName="{{ defaultLanguage }}" />
            <mat-error *ngIf="titleFormGroup.controls[defaultLanguage].hasError('required')">
                {{ 'aumico_templates_group_form_enter_group_title_error' | i18next }}
            </mat-error>
        </mat-form-field>
    </div>
    <div [formGroup]="totalNameFormGroup">
        <mat-form-field>
            <mat-label>{{ 'aumico_templates_group_form_total_name' | i18next }}</mat-label>
            <input matInput formControlName="{{ defaultLanguage }}" />
            <mat-error *ngIf="totalNameFormGroup.controls[defaultLanguage].hasError('required')">
                {{ 'aumico_templates_group_form_enter_group_total_name_error' | i18next }}
            </mat-error>
        </mat-form-field>
    </div>
    <br />
    <mat-checkbox [(ngModel)]="hideTotal" id="hide-total-checkbox">
        {{ 'aumico_templates_group_form_hide_total' | i18next }}
    </mat-checkbox>
    <br />
    <mat-label>{{ 'aumico_templates_group_form_select_option' | i18next }}</mat-label>
    <br />
    <mat-checkbox [disabled]="isEditMode" [(ngModel)]="allowGroups" id="allow-groups-checkbox">
        {{ 'aumico_templates_group_form_allow_groups' | i18next }}
    </mat-checkbox>
    <br />
    <mat-checkbox [disabled]="isEditMode" [(ngModel)]="allowItems" id="allow-items-checkbox">
        {{ 'aumico_templates_group_form_allow_items' | i18next }}
    </mat-checkbox>
    <br />
</div>
<div mat-dialog-actions class="form-action-buttons" *ngIf="!isDefault">
    <aumico-button
        [disabled]="
            nameControl.invalid || (!allowGroups && !allowItems) || titleFormGroup.invalid || totalNameFormGroup.invalid
        "
        (click)="save()"
        id="save-button"
    >
        {{ 'aumico_templates_save' | i18next }}
    </aumico-button>
    <aumico-button (click)="closeDialog()" id="cancel-button">{{ 'aumico_templates_cancel' | i18next }}</aumico-button>
</div>

<div mat-dialog-content class="form" *ngIf="isDefault">
    <div [formGroup]="titleFormGroup">
        <mat-form-field>
            <mat-label>{{ 'aumico_templates_group_form_title' | i18next }}</mat-label>
            <input matInput formControlName="{{ defaultLanguage }}" />
            <mat-error *ngIf="titleFormGroup.controls[defaultLanguage].hasError('required')">
                {{ 'aumico_templates_group_form_enter_group_title_error' | i18next }}
            </mat-error>
        </mat-form-field>
    </div>
    <div [formGroup]="totalNameFormGroup">
        <mat-form-field>
            <mat-label>{{ 'aumico_templates_group_form_total_name' | i18next }}</mat-label>
            <input matInput formControlName="{{ defaultLanguage }}" />
            <mat-error *ngIf="totalNameFormGroup.controls[defaultLanguage].hasError('required')">
                {{ 'aumico_templates_group_form_enter_group_total_name_error' | i18next }}
            </mat-error>
        </mat-form-field>
    </div>
</div>
<div mat-dialog-actions class="form-action-buttons" *ngIf="isDefault">
    <aumico-button [disabled]="titleFormGroup.invalid || totalNameFormGroup.invalid" (click)="save()" id="save-button">
        {{ 'aumico_templates_save' | i18next }}
    </aumico-button>
    <aumico-button (click)="closeDialog()" id="cancel-button">{{ 'aumico_templates_cancel' | i18next }}</aumico-button>
</div>
